let WEBSOCK_URL;

class WebSockAPI {
    
    constructor() {
        this.socket = null;
        this.reqid = 0;
        this.cb = {}; //note: this can get quite large!!
        // there seems to be no good way to save the access token across Lambda invocations
        // so we pretty much have to send it with each request
        this.accessToken = null;
        this.partial = {}; //reqid=>partial messages
        //todo: if closed then we should error out cbs that have not returned
    }

    is_connected() {
        //todo decide if CONNECTING is good enough
        return this.socket && this.socket.readyState === WebSocket.OPEN
    }
    
    // this gets called occasionally to make sure connection is up
    // if it is already up, then just send the new access token
    // this ensures that access on server side is up-to-date
    connect(accessToken) {
        if(!WEBSOCK_URL) {
            //todo figure out websock url - is this right?
            fetch(process.env.REACT_APP_API_NAMESPACE + '/config/ws').then((res) => {
                res.json().then((w) => {
                    WEBSOCK_URL = w.websocket_url;
                    return this.connectURL(WEBSOCK_URL, accessToken);            
                });
            });
        } else {
            return this.connectURL(WEBSOCK_URL, accessToken);
        }
    }
    connectURL(url, accessToken) {
        this.accessToken = accessToken;
        if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
            console.warn("WebSocket is already connected or connecting.");
            //should just send access token if already up
            return;
        }
        this.socket = new WebSocket(url+"?token="+encodeURIComponent(accessToken));
        this.socket.onopen = (event) => {
            console.log(`[WebSocket] Connected to ${url}`);
        };
        this.socket.onmessage = (event) => {
            // reqid, part, total, json_fragment
            const commas = []
            let data = event.data;
            if(data.slice(0,1) === '{') {
                console.log("WS Error", event.data);
                return;
            }
            const c1 = data.indexOf(",")
            const c2 = data.indexOf(",",c1+1)
            const c3 = data.indexOf(",",c2+1)
            const reqid = parseInt(data.slice(0,c1))
            const p0 = parseInt(data.slice(c1+1,c2))
            const p1 = parseInt(data.slice(c2+1,c3))
            const part = data.slice(c3+1)
            console.log("WSPART", reqid, p0, p1)
             if(p1 === 1 && p0 === 0) {
                data = part
            } else {
                 if(p0 === 0) {
                     this.partial[reqid] = [part]
                 } else {
                     const arr = this.partial[reqid];
                     console.log("Push onto", reqid, arr);
                     arr.push(part)
                     
                 }
                if(p0 + 1 === p1) {
                    data = this.partial[reqid].join('') //join the parts
                    delete this.partial[reqid]
                } else {
                    return; //wait for more parts
                }
            }
            try {
                // Attempt to parse JSON data automatically
                data = JSON.parse(data);
            } catch (e) {
                // Fallback to raw string if it's not JSON
            }
            console.log("WS data",data, event);
            const resolve_reject = this.cb[reqid];
            if(resolve_reject) {
                delete this.cb[reqid];
                try {
                    resolve_reject[0](data);
                } catch(err) {
                    resolve_reject[1](err);
                }
            }
            //todo: expire promises after about 2 minutes
        };
        this.socket.onclose = (event) => {
            console.log(`[WebSocket] Connection closed (Code: ${event.code})`);
            this.socket = null;
            this.reject_pending();
        };
        this.socket.onerror = (error) => {
            console.error('[WebSocket] Error occurred', error);
        };
    }

    send(action, payload = {}, resolve_reject = null) {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
            console.error("[WebSocket] Cannot send message: connection is not open.");
            return;
        }
        this.reqid++;
        const messageData = JSON.stringify({
            action: action,
            accessToken: this.accessToken,
            ...payload,
        });
        this.cb[this.reqid] = resolve_reject;
        this.socket.send(`${this.reqid},0,1,`+messageData);
    }
    reject_pending() {
        const rej = this.cb;
        const err = new Error("socket closed");
        this.cb = {}
        this.partial = {}        
        Object.values(rej).map((resolve_reject) => resolve_reject[1](err));
    }
    close(code = 1000, reason = "Client closed connection") {
        if (this.socket) {
            this.socket.close(code, reason);
            this.reject_pending();
        }
    }
}

// Create singleton from Auth service
const websockapi = new WebSockAPI();
export default websockapi;
